import type { FieldError, UseFormRegisterReturn } from "react-hook-form";
/** Shared writing controls; parent forms own schema, authority and publication. */
export function GoalWritingFields({
  title,
  description,
  successCriteria,
  errors = {},
  autoFocus = false,
}: {
  title: UseFormRegisterReturn;
  description: UseFormRegisterReturn;
  successCriteria: UseFormRegisterReturn;
  autoFocus?: boolean;
  errors?: {
    title?: FieldError;
    description?: FieldError;
    successCriteria?: FieldError;
  };
}) {
  const fields = [
    {
      label: "Goal title",
      registration: title,
      test: "title",
      rows: 0,
      placeholder: "Scan before receiving",
      max: 160,
      error: errors.title,
    },
    {
      label: "Action plan",
      registration: description,
      test: "description",
      rows: 3,
      placeholder: "What should the player try next?",
      max: 2000,
      error: errors.description,
    },
    {
      label: "Success criteria",
      registration: successCriteria,
      test: "success-criteria",
      rows: 2,
      placeholder: "How will we know this goal is working?",
      max: 2000,
      error: errors.successCriteria,
    },
  ];
  return (
    <>
      {fields.map((field) => (
        <label
          key={field.test}
          className="flex flex-col gap-1 text-sm text-ink"
        >
          {field.label}
          {field.rows ? (
            <textarea
              {...field.registration}
              placeholder={field.placeholder}
              aria-invalid={!!field.error}
              rows={field.rows}
              maxLength={field.max}
              data-testid={`goal-composer-${field.test}`}
              className="rounded-control border border-rule bg-canvas px-3 py-2 focus-visible:ring-2 focus-visible:ring-accent"
            />
          ) : (
            <input
              {...field.registration}
              placeholder={field.placeholder}
              aria-invalid={!!field.error}
              autoFocus={autoFocus}
              maxLength={field.max}
              data-testid={`goal-composer-${field.test}`}
              className="rounded-control border border-rule bg-canvas px-3 py-2 focus-visible:ring-2 focus-visible:ring-accent"
            />
          )}
          {field.error && (
            <span role="alert" className="text-danger">
              {field.error.message}
            </span>
          )}
        </label>
      ))}
    </>
  );
}
